import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1uqiazbote: FaireBrandEntity = {
  token: "b_1uqiazbote",
  type: "brand",
  name: "Heavenly Scents",
  avatarUrl:
    "https://cdn.faire.com/fastly/612caeac89ddf722e5fb1202ddadc0ee66ee26b75a91b7ce5fee6ba7abf044c7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4a44623fbdac2b72bc8a55df0f28035b9f1b3e1c2edaa06535d9a4c92429be67.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/612caeac89ddf722e5fb1202ddadc0ee66ee26b75a91b7ce5fee6ba7abf044c7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4a44623fbdac2b72bc8a55df0f28035b9f1b3e1c2edaa06535d9a4c92429be67.webp",
  location: "Sylacauga, AL, USA",
  minimumOrderDollars: 25,
  rating: 4.8,
  reviewCount: 190,
  isInsider: true,
  description:
    "Heavenly Scents is dedicated to helping small business owners grow and market their brands by providing high quality and cost effective products. We do this by  providing no labeled products or private label products, which allows you (the business owner) to have complete control over your labeling and branding. With various types of products, there is something for every price entry point and business model. We look forward to working with you and helping you succeed in growing your business.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:44.299Z",
    importedBy: "entity-db-cli",
  },
};
